import { useTranslation } from 'react-i18next';
import { Flex, Heading, Text } from '@radix-ui/themes';
import { WizardScreen } from '@/components/layout';
import { ContinueButton, OnboardingWizardHeader } from '@/components/onboarding';
import { PhotoGrid } from '@/components/profile/PhotoGrid';
import { useOnboardingStore } from '@/stores/onboardingStore';
import type { OnboardingStepProps } from './types';
import { useSaveAndNext } from './useSaveAndNext';

export function PhotosStep({ flow }: OnboardingStepProps) {
  const { t } = useTranslation('onboarding');
  const photos = useOnboardingStore(state => state.photos);
  const uploading = useOnboardingStore(state => state.uploading);
  const error = useOnboardingStore(state => state.error);
  const uploadPhoto = useOnboardingStore(state => state.uploadPhoto);
  const removePhoto = useOnboardingStore(state => state.removePhoto);
  const reorderPhotos = useOnboardingStore(state => state.reorderPhotos);
  const saveAndNext = useSaveAndNext(flow);

  return (
    <WizardScreen header={<OnboardingWizardHeader flow={flow} />}>
      <Flex direction="column" gap="4" py="2" pb="5">
        <Heading size="5" weight="light">
          {t('steps.photos.title')}
        </Heading>
        {error && (
          <Text size="1" color="red">
            {error}
          </Text>
        )}
        <Text size="2" color="gray">
          {t('steps.photos.description')}
        </Text>
        <PhotoGrid
          photos={photos}
          uploading={uploading}
          onUpload={uploadPhoto}
          onRemove={removePhoto}
          onReorder={(from, to) => void reorderPhotos(from, to)}
        />
        <ContinueButton onClick={saveAndNext} disabled={photos.length < 2}>
          {t('actions.continue')}
        </ContinueButton>
      </Flex>
    </WizardScreen>
  );
}
